import Page from "../pages/Ventures";
import { pageMeta } from "../lib/meta";
export const meta = () => pageMeta({ title: "Ventures | Gazar", description: "Three products I own and still maintain: ClubCP, software for community clubs; Coding, timed TypeScript drills with spaced repetition; and Marlin, an open source terminal for running coding agents.", path: "/ventures" });
export default function Ventures() { return <Page />; }
